export class PrecificacaoUF {
  uf: string;
  percentual: number;
  tipoDa?: number;
}
